import axiosInstance from "../utils/axiosInstance";
import { Banner } from "../interfaces/banner.interface";
import { normalizeActiveStorageUrl } from "../utils/imageUrl";

interface PagedSlides {
  slides: Banner[];
  totalPages: number;
  totalCount: number;
}

// The paginated slides endpoint behind the v2 banner listing pages. Note the
// payload is flat (desktop_image / mobile_image) unlike the legacy
// /api/v1/banner response, which nests them under `image`.
class SlidesApi {

  getSlides(category: string, page: number = 1): Promise<PagedSlides> {
    const apiUrl = "/b2c2b/api/v1/slides";

    return axiosInstance.get(apiUrl, { params: { category, page } })
    .then(response => {
      const slides: Banner[] = response.data.data.map(({ id, attributes }) => {
        const slide: Banner = {
          id: Number(id),
          title: attributes.title,
          url: attributes.url,
          target: attributes.target,
          sortOrder: attributes.sort_order,
          desktopImage: normalizeActiveStorageUrl(attributes.desktop_image),
          mobileImage: normalizeActiveStorageUrl(attributes.mobile_image),
        };
        return slide;
      });
      return Promise.resolve({
        slides,
        totalPages: response.data.meta.total_pages,
        totalCount: response.data.meta.total_count,
      });
    });
  }

}

export default SlidesApi;
